import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type AgentWithId = {
  idAgent: number;
};

// Базовый тип для create/update операций агента
type AgentCreateUpdateData = AgentWithId & {
  code: string;
  agentSettings: unknown;
};

// Типы для WebSocket сообщений компонента agents
type AgentListMessage = WebSocketMessageWithFields<'agent-list' | 'helper-agents', {
  agents: unknown[];
}>;
type AgentCreateMessage = WebSocketMessageWithFields<'agent-create' | 'agent-create-success', AgentCreateUpdateData>;
type AgentUpdateMessage = WebSocketMessageWithFields<'agent-update' | 'agent-update-success', AgentCreateUpdateData>;
type AgentDeleteMessage = WebSocketMessageWithFields<'agent-delete' | 'agent-delete-success', AgentWithId>;
type AgentLockMessage = WebSocketMessageWithFields<'agent-lock' | 'agent-lock-success', AgentWithId>;
type AgentUnlockMessage = WebSocketMessageWithFields<'agent-unlock' | 'agent-unlock-success', AgentWithId>;

// Объединенный тип для всех сообщений
type AgentsWebSocketMessage = 
  | AgentListMessage 
  | AgentCreateMessage 
  | AgentUpdateMessage 
  | AgentDeleteMessage 
  | AgentLockMessage 
  | AgentUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataAgents',
},
  __name: 'agents',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID агента
const handleWebSocketMessage = (data: AgentsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'agent-list':
    case 'helper-agents':
      store.dispatch('agent/wsSetAgents', { agents: data.agents });
      break;
    case 'agent-create':
    case 'agent-create-success':
      store.dispatch('agent/wsAgentCreate', {
        idAgent: data.idAgent,
        code: data.code,
        agentSettings: data.agentSettings,
      });
      break;
    case 'agent-update':
    case 'agent-update-success':
      store.dispatch('agent/wsAgentUpdate', {
        idAgent: data.idAgent,
        code: data.code,
        agentSettings: data.agentSettings,
      });
      break;
    case 'agent-delete':
    case 'agent-delete-success':
      store.dispatch('agent/wsAgentDelete', {
        idAgent: data.idAgent,
      });
      break;
    case 'agent-lock':
    case 'agent-lock-success':
      store.dispatch('agent/wsAgentLock', {
        idAgent: data.idAgent,
      });
      break;
    case 'agent-unlock':
    case 'agent-unlock-success':
      store.dispatch('agent/wsAgentUnlock', {
        idAgent: data.idAgent,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})